import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=21ec11d0&scoped=true&"
import script from "./deal.vue?vue&type=script&lang=js&"
export * from "./deal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec11d0",
  null
  
)

export default component.exports